import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import { LibraryItemDetailPageCoverImage_CoverImageFragmentDoc } from '../libraryItem/LibraryItemDetailPageContainer.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AdminRecentlyEditedModulesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AdminRecentlyEditedModulesQuery = { __typename?: 'Query', AdminLibrary: { __typename?: 'LibraryItems', objects: Array<{ __typename?: 'LibraryItem', id: string, lastEditedAt?: string | null, name: { __typename?: 'TranslationSet', uuid: string, en: string }, module?: { __typename?: 'Module', id: number, libraryItem: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, en: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, mediaUrl?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null } } | null }> } };


export const AdminRecentlyEditedModulesDocument = gql`
    query AdminRecentlyEditedModules {
  AdminLibrary(
    input: {filters: {itemType: {value: MODULE}}, sort: {column: "lastEdited", descending: true, nullsLast: true}}
    pagination: {limit: 10}
  ) {
    objects {
      id
      name {
        uuid
        en
      }
      lastEditedAt
      module {
        id
        libraryItem {
          id
          name {
            uuid
            en
          }
          coverImage {
            ...LibraryItemDetailPageCoverImage_CoverImage
          }
        }
      }
    }
  }
}
    ${LibraryItemDetailPageCoverImage_CoverImageFragmentDoc}`;

/**
 * __useAdminRecentlyEditedModulesQuery__
 *
 * To run a query within a React component, call `useAdminRecentlyEditedModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminRecentlyEditedModulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminRecentlyEditedModulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminRecentlyEditedModulesQuery(baseOptions?: Apollo.QueryHookOptions<AdminRecentlyEditedModulesQuery, AdminRecentlyEditedModulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminRecentlyEditedModulesQuery, AdminRecentlyEditedModulesQueryVariables>(AdminRecentlyEditedModulesDocument, options);
      }
export function useAdminRecentlyEditedModulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminRecentlyEditedModulesQuery, AdminRecentlyEditedModulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminRecentlyEditedModulesQuery, AdminRecentlyEditedModulesQueryVariables>(AdminRecentlyEditedModulesDocument, options);
        }
export type AdminRecentlyEditedModulesQueryHookResult = ReturnType<typeof useAdminRecentlyEditedModulesQuery>;
export type AdminRecentlyEditedModulesLazyQueryHookResult = ReturnType<typeof useAdminRecentlyEditedModulesLazyQuery>;
export type AdminRecentlyEditedModulesQueryResult = Apollo.QueryResult<AdminRecentlyEditedModulesQuery, AdminRecentlyEditedModulesQueryVariables>;